import { render, staticRenderFns } from "./LiveDashboard.vue?vue&type=template&id=527fd4e0&scoped=true"
import script from "./LiveDashboard.vue?vue&type=script&lang=js"
export * from "./LiveDashboard.vue?vue&type=script&lang=js"
import style0 from "./LiveDashboard.vue?vue&type=style&index=0&id=527fd4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527fd4e0",
  null
  
)

export default component.exports